import React, { Component, createRef, Dispatch } from 'react';
import LoginForm from './login-form';
import ResetPasswordForm from './reset-password-form';
import MyForgotPasswordQuestion from './my-forgot-password-question';
import CNewPassword from './set-new-password';
import { Log, Level, Logger } from 'ng2-logger';
import { ILoginState, ILoginProps, ILoginPageData } from '../../models/pages/login';
import CSendVerifyMail from './send-verify-mail';
import Translator from '../../core/i18n';
import LoginAnnouncements from './login-announcements';
import PopupComponent from './popup-component';
import { Route, Redirect } from 'react-router';
import { IAppState, IAction } from '../../models/action/core';
import { connect } from 'react-redux';
import * as Actions from '../../store/actions/login';
import * as ProfileActions from '../../store/actions/profile';
import Loading from '../../components/loading/loading';
import queryString from 'querystring';
import LoginPopup from '../../components/login-notification/main';
import { Common } from '../../core/common';
import BaseModal from '../../modal/base-modal/main';
import LoginAnnouncementModal from '../../modal/in-modal/login-announcement/main';
import * as announcementActions from '../../store/actions/announcement';
import { SecureImage } from '../../components/core/secureImage';
import { url } from 'inspector';

const ConstructorLogo = `${process.env.PUBLIC_URL}/images/constructor/constructor_logo_color.png`;

const _logger = Log.create('login.tsx');
const T = Translator.create();
let _common: Common;
let params;
class Login extends React.Component<ILoginProps, ILoginState> {

    public state: ILoginState;
    constructor(props: ILoginProps) {
        super(props);
        this.state = {
            showModal: false,
            modalData: '0',
            modalHeaderData: '',
            isAnnouncementContentModalOpen: false,
            isLoading: false
        };
        _common = new Common();
        params = new URLSearchParams(props.location.search);
        const getpasswordrecovery = params.get('token');
        if (getpasswordrecovery) {
            // Reset password
            this.props.dispatch(Actions.setCurrentPage('NewPassword', getpasswordrecovery));
        } else {
            // Sign in
            this.props.dispatch(Actions.setCurrentPage('Login', ''));
        }
    }

    public componentWillMount() {
        this.props.dispatch(announcementActions.GetLoginAnnouncement(this.props.organizationId));
    }

    triggerAnnouncementContentModal = () => {
        this.setState({
            ...this.state,
            isAnnouncementContentModalOpen: !this.state.isAnnouncementContentModalOpen,
        });
    };

    public handleModalShowClick = (e: any) => {
        this.setState({
            modalData: e,
            showModal: true
        });
    };

    public handleModalCloseClick = () => {
        this.setState({
            showModal: false
        });
    };

    public headerState = (value: string) => {
        if (value) {
            this.setState({ modalHeaderData: value });
        }
    }

    public onBackClick = () => {
        this.props.dispatch(Actions.setCurrentPage('Login', ''));
    }

    public hideSidebar = () => {
        $('.notices').hide();
        $('.alms-from2').hide();
        $('#hide-sidebar').hide();
        $('.natify').hide();
        $('.suprise').removeClass('d-none');
        $('.suprise').addClass('display_sm_none');
        $('.alms-form2').addClass('d-none');
        // $(".alms-form2").addClass("col-md-1");
        $('.alms-ekstra').addClass('col-md-1');

        $('.alms-form').removeClass('display_sm_none');
    }

    public showSidebar = () => {
        $('.notices').show();
        $('#hide-sidebar').show();
        $('.alms-from2').show();
        $('.natify').show();
        $('.suprise').addClass('d-none');
        $('.alms-ekstra').removeClass('col-md-1');

        $('.alms-form2').removeClass('display_sm_none');
        $('.alms-form2').removeClass('d-none');
        // $(".alms-form2").removeClass("col-md-1");
    }
    public showSidebarMobile = () => {
        $('.notices').show();
        $('.alms-form').addClass('display_sm_none');
        $('.alms-from2').show();
        $('.natify').show();
        $('.alms-ekstra').removeClass('col-md-1');
        $('#hide-sidebar').show();
        $('.alms-form2').removeClass('display_sm_none');
        $('.alms-form2').removeClass('d-none');
        // $(".alms-form2").removeClass("col-md-1");
    }
    public changeLanguage = (lang: string) => {
        this.props.dispatch(ProfileActions.setChangeLoginLanguageAction(lang));
    }

    public onAnnouncementClick(announcementId: string) {
        this.props.dispatch(announcementActions.GetLoginAnnouncementById(announcementId, 'getLoginAnnouncement', 'get'));
        this.triggerAnnouncementContentModal();
    }

    onClickRefresh = () => {
        this.props.dispatch(announcementActions.GetLoginAnnouncement(this.props.organizationId));
        this.setState({ isLoading: true },)

        setTimeout(() => {
            this.setState({ isLoading: false });
        }, 500);
    };

    returnFormContent = () => {
        let formContent;
        if (this.props.isResetPassword) {
            formContent = <CNewPassword />;
        } else if ((this.props.currentPage === 'Login' || !this.props.currentPage)) {
            formContent = <LoginForm />;
        } else if (this.props.currentPage === 'ResetPassword') {
            formContent = <ResetPasswordForm />;
        } else if (this.props.currentPage === 'MyForgotPasswordQuestion') {
            formContent = <MyForgotPasswordQuestion />;
        } else if (this.props.currentPage === 'NewPassword') {
            formContent = <CNewPassword />;
        } else if (this.props.currentPage === 'WrongAddress') {
            formContent = <Redirect to={window.appSettings.DEFAULT_URL + '/wrong-address'} />;
        }
        return formContent;
    }

    returnNoAnnouncementContent = () => {
        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '1em', justifyContent: 'center' }}>
                <p style={{ margin: '0' }}>{T.t('r_login_announcements_not_found')}</p>
                {this.props.loginAnnouncementError && (
                    <button
                        className='alms-btn btn-default btn-icon'
                        onKeyDown={event => {
                            if (event.key === 'Enter') {
                                this.onClickRefresh();
                            }
                        }}
                        style={{
                            maxHeight: "30px",
                            maxWidth: "170px",
                            width: "100%",
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                        onClick={this.onClickRefresh}
                        tabIndex={0}
                    >
                        {this.state.isLoading && (
                            <div id="loading-bar-spinner" className="spinner">
                                <div className="spinner-icon" />
                            </div>
                        )}
                        <img
                            style={{ cursor: 'pointer', marginInlineEnd: "5px" }}
                            src={_common.GetDefaultIcons('refresh')}
                            alt="refresh"
                        />
                        {T.t('r_refresh_activities')}
                    </button>
                )}
            </div>
        )
    }
    public viewMobileApps ()
    {
        return ( <>
        <a href={_common.storeLinks(this.props.culture, 1)} target='_blank'><img className='img-fluid' src={_common.GetMobileAppAnnouncement('playstore')} alt="" /></a>
        <a href={_common.storeLinks(this.props.culture, 2)} target='_blank'><img className='img-fluid' src={_common.GetMobileAppAnnouncement('appstore')} alt="" /></a>
        </>
        )
    }
    public render() {
        if (this.props.pageData) {
            let formContent = this.returnFormContent();
            return (
                <div className="d-md-flex  xy">
                    <div className="col-12  bg-login" style={{ backgroundColor: this.props.pageData.backgroundColor, backgroundImage: `url( ${this.props.pageData.backgroundPath} )` }}>
                        <div className="d-flex h-100">
                            <div className=" alms-form ">
                                <div className="row h-100 mx-0">
                                    <div className=" col-12 alms-form-bg d-flex flex-column">

                                        <div className="row form-padding " >
                                            <a href="#" aria-label="Show Sidebar" className="d-none natify-3 display_sm mobile_natify" onClick={this.showSidebarMobile} />
                                            <div className="col-12 text-center mt-5 mb-2 ">
                                                <img
                                                    src={this.props.pageData.logoPath}
                                                    alt="Logo"
                                                    className="alms-login-img text-center mx-auto "
                                                    onError={(e) => {
                                                        e.currentTarget.onerror = null;
                                                        e.currentTarget.src = ConstructorLogo;
                                                    }}
                                                />
                                                <h4 className='mt-4 subheading2'>{T.t('r_gen_welcome')}</h4>
                                            </div>
                                            {formContent}


                                        </div>
                                        <div className="row market-section">
                                            <div className=" d-flex gap-2">
                                              {this.viewMobileApps()}
                                            </div>
                                            <div  >
                                                <div className="lang-menu float-end d-flex" style={{ float: 'inline-end' }}>
                                                    <div className="selected-lang">{
                                                        this.props.culture ? (
                                                            this.props.culture === 'en-US' ? 'English' : this.props.culture === 'ar-SA' ? 'عربي' : 'Türkçe'
                                                        ) : (T.t('r_choose_language'))
                                                    }</div>
                                                    <ul>
                                                        <li><a className="dropdown-item" onClick={this.changeLanguage.bind(this, 'tr-TR')}>Türkçe</a></li>
                                                        <li><a className="dropdown-item" onClick={this.changeLanguage.bind(this, 'en-US')}>English</a></li>
                                                        <li><a className="dropdown-item" onClick={this.changeLanguage.bind(this, 'ar-SA')}>عربي</a></li>

                                                    </ul>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="suprise d-none alms-formm ">
                                <a href="#" id="show-sidebar" onClick={this.showSidebar} className=" natify-3" aria-label="Show Sidebar" />
                            </div>
                            <div className="display_sm_none alms-form2">
                                <div style={{ margin: 'auto 0 0 0' }}>
                                    <div className="col-12 alms-ekstra ms-md-auto" style={{ overflowY: 'auto' }}>
                                        <div className="row">
                                            <div className="col-12 nat-top">
                                                <a href="#" id="hide-sidebar" onClick={this.hideSidebar} className="natify-2" aria-label="Show Sidebar"></a>

                                            </div>
                                            <div className="notices col-12">
                                                <div className={(!_common.isArabic(this.props.pageData.headerText, document.body.getAttribute('dir')) ? ' arabic-text-direction' : '')} dangerouslySetInnerHTML={{ __html: this.props.pageData.headerText }} />
                                            </div>
                                            <div className="notices col-12 mt-5">
                                                <a className="notice">{T.t('r_menu_announcements')}</a>
                                                {this.props.announcementData && this.props.announcementData.length > 0 ?
                                                    (
                                                        this.props.announcementData.map((x, index) =>
                                                            <a key={index} href="#" onClick={this.onAnnouncementClick.bind(this, x.announcementId)} className={(!_common.isArabic(x.subject) && 'left-text') + ' d-block alms-link'}>{x.subject}</a>
                                                        )
                                                    ) :
                                                    (
                                                        this.returnNoAnnouncementContent()

                                                    )
                                                }
                                            </div>
                                            <div className="notices col-12 mt-5">
                                            <div dangerouslySetInnerHTML={{ __html: this.props.pageData.footerText }} ></div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <BaseModal
                        minWidth={1100}
                        modalIsOpen={this.state.isAnnouncementContentModalOpen}
                        onClose={this.triggerAnnouncementContentModal}
                        headerState={this.state.modalHeaderData}
                        headerIcon={'clock'}
                        showHeader={true}
                    >
                        <LoginAnnouncementModal headerState={this.headerState} />
                    </BaseModal>
                </div>
            );
        }
    }
}

const mapStateToProps = (state: IAppState, ownProps: ILoginProps): ILoginProps => {

    if (!state) {
        return ownProps;
    }

    const loginPageData: ILoginPageData = {
        backgroundColor: state.login.login.backgroundColor,
        backgroundPath: state.login.login.backgroundPath,
        organizationLogo: state.login.login.organizationLogo,
        headerBackgroundImage: state.login.login.headerBackgroundImage,
        footerText: state.login.login.footerText,
        headerText: state.login.login.headerText,
        logoPath: state.login.login.logoPath,
        organizationId: state.login.login.organizationId,
        organizationName: state.login.login.organizationName,
        abbreviation: state.login.login.abbreviation,
        trackingGuid: state.login.login.trackingGuid,
        forgotMyPassword: state.login.login.forgotMyPassword,
        forgotPasswordEnable: state.login.login.forgotPasswordEnable,
        requiresQuestionAndAnswer: state.login.login.requiresQuestionAndAnswer,
        forgotPasswordURLLink: state.login.login.forgotPasswordURLLink,
        forgotPasswordUrlRecover: state.login.login.forgotPasswordUrlRecover,
        requisiteMinPasswordLength: state.login.login.requisiteMinPasswordLength,
        minNonAlphanumericLength: state.login.login.minNonAlphanumericLength,
        forceChangePassword: state.login.login.forceChangePassword,
        isAlmsPlusLoginPage: state.login.login.isAlmsPlusLoginPage,
        displayContentSyncPage: state.login.login.displayContentSyncPage,
    };

    const newProps: ILoginProps = Object.assign({}, ownProps, {
        currentPage: state.login.login.currentPage,
        username: state.login.identitiy.userName,
        pageData: loginPageData,
        announcementData: state.announcement.announcementData,
        organizationId: state.login.login.organizationId,
        culture: state.login.loginCulture,
        loginAnnouncementError: state.announcement.loginAnnouncementError
    });

    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => ({
    dispatch
});

const CLogin = connect(
    mapStateToProps,
    dispatchProps
)(Login);

export default CLogin;
